'use strict';

window.mzMobileOptions = {
    zoomPosition: 'inner',
    expand: 'window',
    closeOnClickOutside: true,
    lazyZoom: true,
    autostart: false
};

window.mzOptions = {
    zoomMode: 'off',
    cssClass: 'white-bg',
    closeOnClickOutside: true,
    lazyZoom: true,
    autostart: false,

    onExpandOpen: function () {
        if (!$('.controls-inner-wrapper').length) {
            $('.mz-expand-controls').children().not('.mz-button-close').wrapAll(("<div class='controls-inner-wrapper' />"));
        }

        var mainImages = $('.pdp-carousel .pdp-main-image-carousel-item');
        /* To update the thumbnail images in magicZoom popup */
        $('.magic-thumb img').each(function (index) {
            var mainImageSrc = $(mainImages[index]).data('original-image-url');
            $(this).attr('src', mainImageSrc);
        });
    },
    onExpandClose: function () {
        // A max height and max width is getting added via a style attribute by some third party JS library to the active image in the carousel.
        // This is preventing the full image from being shown, when we close a magic zoom window on PDP in mobile view
        // Below code changes are for removing these style values when customer closes the magic zoom window on mobile PDP
        var image = $('.pdp-carousel .carousel-item.active .carousel-item-img');
        if (image.length > 0) {
            var style = image.attr('style');
            style = style.replace(/max-width: [^;]*;?/, '');
            style = style.replace(/max-height: [^;]*;?/, '');
            style = style.trim();
            image.attr('style', style);
        }
    }
};
